import { useState, useEffect, useContext } from 'src/ReactTS';
import { Auth, Cache } from 'aws-amplify';
import * as AWS from 'aws-sdk';
import { ServiceContext } from '../provider/Service.provider';
import { IAuthInterface } from '../interface/user/login/IAuthInterface';
import { UserTypeEnum } from '../enum/UserTypeEnum';
import { IUserSecurityDto } from '../interface/user/IUserSecurityDto';
import ConfigService from '../config/config.service';
import { AdminCreateUserRequest, AdminSetUserPasswordRequest, AdminUpdateUserAttributesRequest } from 'aws-sdk/clients/cognitoidentityserviceprovider';
import { AuthPermissions } from './AuthPermissions';
// import { ShowNotification } from 'src/components/common/// ShowNotification/// ShowNotification';
import { RecaptchaToken } from 'src/util/Recaptcha';

export const defaultTemporaryPassword = "Redefinir@123";

export function useAuthProvider(): IAuthInterface {
  const { userAuthService } = useContext(ServiceContext);

  const [
    currentEmail,
    setCurrentEmail
  ] = useState<string | null | undefined>(undefined);
  const [
    currentUser,
    setCurrentUser
  ] = useState<any>(undefined);

  const provider = {
    signUp: async (email: string, password: string) => {
      return Auth.signUp({
        password,
        username: email.toLowerCase(),
        attributes: {
          email: email.toLowerCase()
        }
      });
    },
    confirmSignUp: async (email: string, code: string) => {
      return new Promise<any>(async (res, reject) => {
        try {
          res(await Auth.confirmSignUp(email.toLowerCase(), code));
        } catch (e) {
          if (e.code === 'UnexpectedLambdaException' || e.code === 'NotAuthorizedException') {
            res(true);
          } else {
            reject(e);
          }
        }
      });
    },
    signIn: async (email: string, password: string) => {
      try {
        Cache.setItem('jwt', null);

        const result = await Auth.signIn(email.toLowerCase(), password);

        if (result.challengeName === 'NEW_PASSWORD_REQUIRED') {
          throw result;
        }
        const token = await RecaptchaToken();
        const user = await userAuthService.getAdminUser(token);
        if (user.active === false) {
          throw new Error('Usuário Inativo');
        }

        setCurrentEmail(email.toLowerCase());
        setUserPermissions(user);
        setCurrentUser(user);

        AWS.config.region = ConfigService.getConfig().awsConfig.cognitoRegion;
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
          IdentityPoolId: ConfigService.getConfig().awsConfig.userPoolIdentityPoolId
        });

        (AWS.config.credentials as AWS.CognitoIdentityCredentials).refresh(function (error) {
          // if (error) {
          //   // ShowNotification.Error('Credenciais de dados', 'Erro ao atualizar as credenciais');
          // } else {
          //   // ShowNotification.Success('Dados de credenciais', 'Dados de credenciais atualizadas');
          // }
        });

        const cognitoidentityserviceprovider = new AWS.CognitoIdentityServiceProvider();

        cognitoidentityserviceprovider.config.region = ConfigService.getConfig().awsConfig.cognitoRegion;
        cognitoidentityserviceprovider.config.credentials.accessKeyId = ConfigService.getConfig().awsConfig.userPoolWebClientId;
        cognitoidentityserviceprovider.config.credentials.secretAccessKey = '';
      } catch (error) {
        // ShowNotification.Error('Login', 'Erro ao tentar fazer login');
        throw error;
      }
    },
    signOut: async () => {
      Cache.setItem('jwt', null);

      return Auth.signOut().then(x => {
        setCurrentUser(null);
        setCurrentEmail(null);
        return x;
      });
    },
    completeNewPassword: async (user: any, newPass: string) => {
      return Auth.completeNewPassword(user, newPass, user.challengeParam.requiredAttributes);
    },
    requestEmailConfirmation: async (email: string) => {
      return Auth.resendSignUp(email.toLowerCase());
    },
    forgotPassword: async (email: string) => {
      return Auth.forgotPassword(email);
    },
    forgotPasswordSubmit: async (email: string, code: string, newPassword: string) => {
      return Auth.forgotPasswordSubmit(email, code, newPassword);
    },
    createUserCognito: (email: string, _: string /*profile*/, setDefaultPassword: boolean) => {
      return new Promise<void>((resolve, reject) => {
        AWS.config.region = ConfigService.getConfig().awsConfig.cognitoRegion;
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
          IdentityPoolId: ConfigService.getConfig().awsConfig.userPoolIdentityPoolId
        });

        (AWS.config.credentials as AWS.CognitoIdentityCredentials).refresh(function (error) {
          // if (error) {
          //   // ShowNotification.Error('Credenciais de dados', 'Erro ao atualizar as credenciais');
          // } else {
          //   // ShowNotification.Success('Dados de credenciais', 'Dados de credenciais atualizadas');
          // }
        });
        const cognitoidentityserviceprovider = new AWS.CognitoIdentityServiceProvider();
        cognitoidentityserviceprovider.config.region = ConfigService.getConfig().awsConfig.cognitoRegion;
        cognitoidentityserviceprovider.config.credentials.accessKeyId = ConfigService.getConfig().awsConfig.userPoolWebClientId;
        cognitoidentityserviceprovider.config.credentials.secretAccessKey = '';

        const params: AdminCreateUserRequest = {
          UserPoolId: ConfigService.getConfig().awsConfig.cognitoUserPoolId,
          Username: email.toLowerCase(),
          UserAttributes: [
            {
              Name: 'email',
              Value: email.toLowerCase()
            },
            {
              Name: 'email_verified',
              Value: 'true'
            },
            {
              Name: 'profile',
              Value: 'admin' // profile === 'Administrator' ? 'admin' : profile === 'Officer' ? 'officer' : profile === 'Lawyer' ? 'legal' : 'cartorio'
            }
          ]
        };

        if (setDefaultPassword) {
          params.TemporaryPassword = defaultTemporaryPassword;
        }

        cognitoidentityserviceprovider.adminCreateUser(params, function (err, data) {
          // if (err) {
          //   // ShowNotification.Error('Criação de usuário', 'Erro ao criar o usuário.');
          // } else {
          //   // ShowNotification.Success('Criação de usuário', 'Usuário criado com sucesso.');
          // }
        });
      });
    },
    signInAdministrator: async (email: string, password: string) => {
      try {
        Cache.setItem('jwt', null);

        const result = await Auth.signIn(email.toLowerCase(), password);

        if (result.challengeName === 'NEW_PASSWORD_REQUIRED') {
          throw result;
        }
        const token = await RecaptchaToken();
        const user = await userAuthService.getAdminUser(token);
        if (user.active === false) {
          throw new Error('Usuário Inativo');
        }
        setCurrentEmail(email.toLowerCase());
        setUserPermissions(user);
        setCurrentUser(user);

        AWS.config.region = ConfigService.getConfig().awsConfig.cognitoRegion;
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
          IdentityPoolId: ConfigService.getConfig().awsConfig.userPoolIdentityPoolId
        });
        (AWS.config.credentials as AWS.CognitoIdentityCredentials).refresh(function (error) {
          // if (error) {
          //   // ShowNotification.Error('Credenciais de dados', 'Erro ao atualizar as credenciais');
          // } else {
          //   // ShowNotification.Success('Dados de credenciais', 'Dados de credenciais atualizadas');
          // }
        });

        const cognitoidentityserviceprovider = new AWS.CognitoIdentityServiceProvider();

        cognitoidentityserviceprovider.config.region = ConfigService.getConfig().awsConfig.cognitoRegion;
        cognitoidentityserviceprovider.config.credentials.accessKeyId = ConfigService.getConfig().awsConfig.userPoolWebClientId;
        cognitoidentityserviceprovider.config.credentials.secretAccessKey = '';
      } catch (error) {
        // ShowNotification.Error('', '');
        throw error;
      }
    },

    resetPasswodCognito: (email: string, _: string/*profile*/, setDefaultPassword: boolean) => {
      return new Promise<void>((resolve, reject) => {
        AWS.config.region = ConfigService.getConfig().awsConfig.cognitoRegion;
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
          IdentityPoolId: ConfigService.getConfig().awsConfig.userPoolIdentityPoolId
        });
        const cognitoidentityserviceprovider = new AWS.CognitoIdentityServiceProvider();

        cognitoidentityserviceprovider.config.region = ConfigService.getConfig().awsConfig.cognitoRegion;
        cognitoidentityserviceprovider.config.credentials.accessKeyId = ConfigService.getConfig().awsConfig.userPoolWebClientId;
        cognitoidentityserviceprovider.config.credentials.secretAccessKey = '';

        const paramsUpdate: AdminUpdateUserAttributesRequest = {
          UserPoolId: ConfigService.getConfig().awsConfig.cognitoUserPoolId,
          Username: email.toLowerCase(),
          UserAttributes: [
            {
              Name: 'email',
              Value: email.toLowerCase()
            },
            {
              Name: 'email_verified',
              Value: 'true'
            },
            {
              Name: 'profile',
              Value: 'admin' // profile === 'Administrator' ? 'admin' : profile === 'Officer' ? 'officer' : profile === 'Lawyer' ? 'legal' : 'cartorio'
            }
          ]
        };
        cognitoidentityserviceprovider.adminUpdateUserAttributes(paramsUpdate, function (errUpdate, dataUpdate) {
          if (errUpdate) {
            // ShowNotification.Error('Error atualização de atributos', 'Error ao tentar atualizar os atributos do usuário');
          } else {
            const params: AdminCreateUserRequest = {
              Username: email.toLowerCase(),
              UserPoolId: ConfigService.getConfig().awsConfig.cognitoUserPoolId,
              MessageAction: "RESEND",
              DesiredDeliveryMediums: ["EMAIL"],
            };
            if (setDefaultPassword) {
              params.TemporaryPassword = defaultTemporaryPassword;
            }
            cognitoidentityserviceprovider.adminCreateUser(params, function (err, data) {
              if (err?.code === 'UnsupportedUserStateException') {
                const setUserParams: AdminSetUserPasswordRequest = {
                  Username: email.toLowerCase(),
                  UserPoolId: ConfigService.getConfig().awsConfig.cognitoUserPoolId,
                  Password: defaultTemporaryPassword,
                  Permanent: false
                };
                cognitoidentityserviceprovider.adminSetUserPassword(setUserParams, function (setPassErr, setPassData) {
                  // if (setPassErr) {
                  //   // ShowNotification.Error('Renovar senha', 'Error ao tentar atualizar a senha do usuário.');
                  // }
                  // else {
                  //   // ShowNotification.Success('Renovar senha', 'Senha atualizada com sucesso.');
                  // }
                })
              } else if (err) {
                // ShowNotification.Error('Atualização de atributos', 'Erro ao tentar atualizar os atributos de usuário.');
              } else {
                // ShowNotification.Success('Atualização de atributos', 'Dados de atributos de usuário atualizados.');
              }
            });
          }
        });
      });


      // });
    },
    setPasswordCognito: (email: string, password: string) => {
      return new Promise<void>((resolve, reject) => {
        AWS.config.region = ConfigService.getConfig().awsConfig.cognitoRegion;
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
          IdentityPoolId: ConfigService.getConfig().awsConfig.userPoolIdentityPoolId
        });

        (AWS.config.credentials as AWS.CognitoIdentityCredentials).refresh(function (error) {
          if (error) {
            // ShowNotification.Error('Credenciais de dados', 'Erro ao atualizar as credenciais');
          } else {
            // ShowNotification.Success('Dados de credenciais', 'Dados de credenciais atualizadas');
          }
        });
        const cognitoidentityserviceprovider = new AWS.CognitoIdentityServiceProvider();

        cognitoidentityserviceprovider.config.region = ConfigService.getConfig().awsConfig.cognitoRegion;
        cognitoidentityserviceprovider.config.credentials.accessKeyId = ConfigService.getConfig().awsConfig.userPoolWebClientId;
        cognitoidentityserviceprovider.config.credentials.secretAccessKey = '';
        const params = {
          Username: email,
          UserPoolId: ConfigService.getConfig().awsConfig.cognitoUserPoolId,
          Password: password
        };

        cognitoidentityserviceprovider.adminSetUserPassword(params, function (err, data) {
          if (err) {
            // ShowNotification.Error('Erro ao alterar senha', `Erro ao tentar alterar senha com a seguinte mensagem ${err}`);
          } else {
            // ShowNotification.Success('', 'Senha alterada com sucesso.');
          }
        });
      });
    },
    getUserCognito: (email: string) => {
      return new Promise<any>((resolve, reject) => {
        AWS.config.region = ConfigService.getConfig().awsConfig.cognitoRegion;
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
          IdentityPoolId: ConfigService.getConfig().awsConfig.userPoolIdentityPoolId
        });

        (AWS.config.credentials as AWS.CognitoIdentityCredentials).refresh(function (error) {
          if (error) {
            // ShowNotification.Error('Credenciais de dados', 'Erro ao atualizar as credenciais');
          } else {
            // ShowNotification.Success('Dados de credenciais', 'Dados de credenciais atualizadas');
          }
        });

        const cognitoidentityserviceprovider = new AWS.CognitoIdentityServiceProvider();

        cognitoidentityserviceprovider.config.region = ConfigService.getConfig().awsConfig.cognitoRegion;
        cognitoidentityserviceprovider.config.credentials.accessKeyId = ConfigService.getConfig().awsConfig.userPoolWebClientId;
        cognitoidentityserviceprovider.config.credentials.secretAccessKey = '';

        const params = {
          Username: email,
          UserPoolId: ConfigService.getConfig().awsConfig.cognitoUserPoolId
        };

        cognitoidentityserviceprovider.adminGetUser(params, function (err, data) {
          if (err) {
            // ShowNotification.Error('Consultar dados usuário', 'Erro ao consultar dados do usuário');
          } else {
            // ShowNotification.Success('Consultar dados usuário', `Dados retornados com sucesso. ${data?.Username ?? "Nome não definido"}`);
          }
        });
      });
    },
    sendMailToCognito: (email: string) => {
      provider.getUserCognito(email).then(() => provider.forgotPassword(email)).catch(() => provider.signUp(email, '@alterarprimeirasenha'));
    },

    isLoggedIn: () => !!provider.currentUser,
    isAdministrator: () => !!(provider.currentUser && (
      provider.currentUser.type === UserTypeEnum.Administrator ||
      provider.currentUser.type === UserTypeEnum.Operations ||
      provider.currentUser.type === UserTypeEnum.Consorcio_Administradora ||
      provider.currentUser.type === UserTypeEnum.PAN_Operations ||
      provider.currentUser.type === UserTypeEnum.Business_Partner ||
      provider.currentUser.type === UserTypeEnum.Business_Partner_External ||
      provider.currentUser.type === UserTypeEnum.Business_Partner_Ops ||
      provider.currentUser.type === UserTypeEnum.Custody
    )),
    currentEmail,
    currentUser
  };

  useEffect(() => {
    const isAuthenticated = async () => {
      const currCognitoUser = new Promise<any>(resolve => {
        Auth.currentUserPoolUser().then(resolve).catch(() => resolve(false));
      });

      const ALLOWED_PROFILES = Array.from(['Administrator', 'Operations', 'Consorcio_Administradora', 'Custody', 'PAN_Operations', 'Business_Partner', 'Business_Partner_Ops', 'Business_Partner_External']);

      if (await currCognitoUser) {
        try {
          const baseResponse: any = await userAuthService.getBaseUser();
          const res = baseResponse.data;
          const isAllowed = ALLOWED_PROFILES.find(type => type === res.type);
          if (isAllowed !== undefined) {
            try {
              const token = await RecaptchaToken();
              const user: IUserSecurityDto = await userAuthService.getAdminUser(token);
              setUserPermissions(user);
              setMailAndUser(user);
            } catch (error) {
              setMailAndUser(null);
            }
          }
        } catch (error) {
          setMailAndUser(null);
        }
      } else {
        setMailAndUser(null);
      }
    };

    isAuthenticated();
  }, []);

  function setMailAndUser(arg) {
    setCurrentEmail(arg == null ? arg : arg.login);
    setCurrentUser(arg);
  }

  function setUserPermissions(user: IUserSecurityDto) {
    user.permissions = AuthPermissions(user);
  }

  return provider;
}



// WEBPACK FOOTER //
// ./src/services/middleware/AuthProvider.ts